import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LightboxProvider } from './contexts/lightboxContext';
import initializePostHog from './contexts/posthogManager';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { PostHogProvider } from 'posthog-js/react';

initializePostHog();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider>
      <LightboxProvider>
        <App />
        <SpeedInsights />
      </LightboxProvider>
    </PostHogProvider>
  </React.StrictMode>
);
